import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-platform-set-password',
    templateUrl: './app-platform-set-password.component.html',
    styleUrls: ['./app-platform-set-password.component.scss'],
    standalone: false
})
export class AppPlatformSetPasswordComponent implements OnInit {
    @Input() password: string = '';
    @Input() confirmPassword: string = '';
    @Input() passwordStrengthRegex: any = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,24}$/;
    @Input() mediumRegexPattern: string = '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[^A-Za-z0-9]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[^A-Za-z0-9]))|((?=.*[0-9])(?=.*[^A-Za-z0-9])))(?=.{6,})';
    @Input() strongRegexPattern: string = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})';
    @Input() minLength: number = 8;
    @Input() maxLength: number = 24;
    @Input() passwordPlaceholder: string = 'APP_PLATFORM_LOGIN_CENTER.PASSWORD';
    @Input() confirmPasswordPlaceholder: string = 'APP_PLATFORM_LOGIN_CENTER.CONFIRM_PASSWORD';
    @Input() showFeedback: boolean = true;
    @Input() showToggleMask: boolean = true;

    @Output() passwordChange = new EventEmitter<string>();
    @Output() confirmPasswordChange = new EventEmitter<string>();
    @Output() validityChange = new EventEmitter<{
        valid: boolean;
        passwordMismatch: boolean;
        strengthCheck: any;
    }>();

    public passwordMismatch: boolean = true;
    public passwordStrengthCheck = {
        hasUpperCase: false,
        hasLowerCase: false,
        hasNumber: false,
        hasSpecialChar: false,
        hasValidLength: false,
        valid: false,
        regexMatch: false
    };

    ngOnInit(): void {
        if (this.password) {
            this.checkPassword(this.password);
        }
    }

    public checkPassword(password: string): void {
        this.password = password;
        this.checkPasswordStrength(password);
        if (this.confirmPassword !== '') {
            this.setPasswordMismatch();
        }
        this.passwordChange.emit(this.password);
        this.emitValidityChange();
    }

    public checkConfirmPassword(event?: any): void {
        if (typeof event === 'string') {
            this.confirmPassword = event;
        }
        this.setPasswordMismatch();
        this.confirmPasswordChange.emit(this.confirmPassword);
        this.emitValidityChange();
    }

    public checkPasswordStrength(password: string): void {
        const val = password || '';
        this.passwordStrengthCheck.hasUpperCase = /[A-Z]/.test(val);
        this.passwordStrengthCheck.hasLowerCase = /[a-z]/.test(val);
        this.passwordStrengthCheck.hasNumber = /\d/.test(val);
        this.passwordStrengthCheck.hasSpecialChar = /[^A-Za-z0-9]/.test(val);
        this.passwordStrengthCheck.hasValidLength = val.length >= this.minLength && val.length <= this.maxLength;

        if (this.passwordStrengthRegex) {
            if (this.passwordStrengthRegex instanceof RegExp) {
                this.passwordStrengthCheck.regexMatch = this.passwordStrengthRegex.test(val);
            } else {
                try {
                    this.passwordStrengthCheck.regexMatch = new RegExp(this.passwordStrengthRegex).test(val);
                } catch (e) {
                    this.passwordStrengthCheck.regexMatch = false;
                }
            }
        } else {
            this.passwordStrengthCheck.regexMatch = true;
        }

        this.passwordStrengthCheck.valid =
            this.passwordStrengthCheck.hasUpperCase &&
            this.passwordStrengthCheck.hasLowerCase &&
            this.passwordStrengthCheck.hasNumber &&
            this.passwordStrengthCheck.hasSpecialChar &&
            this.passwordStrengthCheck.hasValidLength &&
            this.passwordStrengthCheck.regexMatch;
    }

    private setPasswordMismatch(): void {
        if (this.password && this.confirmPassword && this.password === this.confirmPassword) {
            this.passwordMismatch = false;
        } else {
            this.passwordMismatch = true;
        }
    }

    private emitValidityChange(): void {
        this.validityChange.emit({
            valid: this.passwordStrengthCheck.valid,
            passwordMismatch: this.passwordMismatch,
            strengthCheck: this.passwordStrengthCheck
        });
    }
}
